export const MAX_DELTA_TIME = 100;
export const MAX_SUBSTEP_TIME = 1000 / 60;

const spring = (current, target, velocity, tension, damping) => {
    const springForce = -tension * (current - target);
    const dampingForce = -damping * velocity;
    return springForce + dampingForce;
};

const integrateSpringProperty = (property, config, deltaSeconds) => {
    const { stiffness, damping, mass } = config;
    const force = spring(property.current, property.to, property.velocity, stiffness, damping);

    property.velocity += (force * deltaSeconds) / mass;
    property.current += property.velocity * deltaSeconds;
};

export const advanceSpringProperty = (property, config, deltaMs) => {
    const cappedDeltaMs = Math.min(deltaMs, MAX_DELTA_TIME);
    // A single long Euler step can inject energy into the spring. Preserve the
    // capped elapsed time, but integrate it in stable, roughly 60Hz slices.
    const substeps = Math.max(1, Math.ceil(cappedDeltaMs / MAX_SUBSTEP_TIME));
    const substepSeconds = cappedDeltaMs / substeps / 1000;

    for (let index = 0; index < substeps; index++) {
        integrateSpringProperty(property, config, substepSeconds);
    }
};
